import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react'
import { CartProvider } from './hooks/cart-context/CartContext';
import { ArticleProvider } from './hooks/article-context/ArticleContext';
import GTMPageView from './GTMPageView';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Router>
      <ChakraProvider>
        <CartProvider>
          <ArticleProvider>
            <GTMPageView />
            <App />
          </ArticleProvider>
        </CartProvider>
      </ChakraProvider>
    </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
